
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundesliga/players/[player]",
      function () {
        return require("private-next-pages/bundesliga/players/[player]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundesliga/players/[player]"])
      });
    }
  